import { Link } from 'react-router-dom'
import styles from './Hero.module.css'

function Hero() {
    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                <div className={styles.content}>
                    <h1 className={styles.title}>
                        Soluciones <span className={styles.highlight}>Inteligentes</span> para tu Empresa
                    </h1>
                    <p className={styles.subtitle}>
                        Transformamos procesos contables y empresariales con inteligencia artificial.
                        Agentes personalizados que optimizan tu operación y potencian tu crecimiento.
                    </p>
                    <div className={styles.ctaButtons}>
                        <Link to="/servicios" className={styles.btnPrimary}>
                            Conocer Servicios
                        </Link>
                        <Link to="/contacto" className={styles.btnSecondary}>
                            Contáctanos
                        </Link>
                    </div>
                </div>

                <div className={styles.visualContainer}>
                    <div className={styles.visual}>
                        <div className={styles.circle}></div>
                        <div className={styles.circle}></div>
                        <div className={styles.circle}></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero
